module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                  Solicitações de Remoção "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(this.pagination.totalItems))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "text-right text-left-xs"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'solicitar-remocao'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n                    Nova Remoção\n                  ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-sm"
  }, [_c('div', {
    staticClass: "panel panel-default wrapper-sm",
    attrs: {
      "id": "filters_main"
    }
  }, [_c('div', {
    staticClass: "row m-l-xs m-r-xs",
    attrs: {
      "id": "filters"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "title_filter",
    attrs: {
      "for": "filtroData"
    }
  }, [_vm._v("Data de Início")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data),
      expression: "filtros.data"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroData"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "data", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reloadData]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                        Qualquer data\n                      ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Hoje'
    }
  }, [_vm._v("Hoje")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": '7dias'
    }
  }, [_vm._v("Últimos 7 dias")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Mes'
    }
  }, [_vm._v("Este mês")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Ano'
    }
  }, [_vm._v("Este ano")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 'Periodo'
    }
  }, [_vm._v("Período")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "title_filter",
    attrs: {
      "for": "filtroCategoria"
    }
  }, [_vm._v("Categoria")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.categoria),
      expression: "filtros.categoria"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroCategoria"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "categoria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reloadData]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                        Todos\n                      ")]), _vm._v(" "), _vm._l((_vm.categorias), function(categoria) {
    return _c('option', {
      domProps: {
        "value": categoria.id
      }
    }, [_vm._v("\n                        " + _vm._s(categoria.nome) + "\n                      ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "title_filter",
    attrs: {
      "for": "filtroPatio"
    }
  }, [_vm._v("Patio de Destino")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.patio),
      expression: "filtros.patio"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroPatio"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "patio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reloadData]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                        Todos\n                      ")]), _vm._v(" "), _vm._l((_vm.patios), function(patio) {
    return _c('option', {
      domProps: {
        "value": patio.id
      }
    }, [_vm._v("\n                        " + _vm._s(patio.nome) + "\n                      ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "title_filter",
    attrs: {
      "for": "filtroStatus"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.status),
      expression: "filtros.status"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroStatus"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reloadData]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                        Todos\n                      ")]), _vm._v(" "), _vm._l((_vm.Status), function(status, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                        " + _vm._s(status.titulo) + "\n                      ")])
  })], 2)])])]), _vm._v(" "), (_vm.filtros.data === 'Periodo') ? _c('div', {
    staticClass: "row m-l-xs m-r-xs"
  }, [_c('div', {
    staticClass: "col-md-6 filtros-periodo-datas form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data1),
      expression: "filtros.data1"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroData1",
      "placeholder": "dd/mm/yyyy",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.data1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "m-l m-r"
  }, [_vm._v("até")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data2),
      expression: "filtros.data2"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filtroData2",
      "placeholder": "dd/mm/yyyy",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.data2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-info m-l",
    attrs: {
      "disabled": !_vm.filtros.data1 || !_vm.filtros.data2
    },
    on: {
      "click": _vm.reloadData
    }
  }, [_vm._v("Pesquisar")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "wrapper clearfix"
  }, [_c('div', {
    staticClass: "col-sm-9 m-b-xs"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "ng-disabled": "pessoaLista.checkeds < 1 ? true : false",
      "aria-disabled": "true",
      "disabled": "disabled"
    }
  }, [_vm._v("Iniciar Campanha de Marketing\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group dropdown"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "disabled": "",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                    Exportar\n                    "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Dropdown link")])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "ng-disabled": "pessoaLista.checkeds < 1 ? true : false",
      "aria-disabled": "true",
      "disabled": "disabled"
    }
  }, [_vm._v("Deletar\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.busca),
      expression: "filtros.busca"
    }],
    staticClass: "input-sm form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar"
    },
    domProps: {
      "value": (_vm.filtros.busca)
    },
    on: {
      "keyup": _vm.pesquisar,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "busca", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buscar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "overflow-x": "unset"
    }
  }, [_c('table', {
    staticClass: "table table-hover table-striped b-t b-light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20px"
    }
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedAll),
      expression: "checkedAll"
    }],
    attrs: {
      "type": "checkbox",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedAll) ? _vm._i(_vm.checkedAll, null) > -1 : (_vm.checkedAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkedAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedAll = $$c
        }
      }, function($event) {
        return _vm.checkAll(_vm.arrayData)
      }]
    }
  }), _c('i')])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.sortResults('nomeAgente')
      }
    }
  }, [_vm._v("\n                    Nome do Agente "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtros.sortBy === 'numero'),
      expression: "filtros.sortBy === 'numero'"
    }],
    class: ("fa fa-caret-" + _vm.iconSortingDirection)
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.sortResults('placa')
      }
    }
  }, [_vm._v("\n                    Placa "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtros.sortBy === 'placa'),
      expression: "filtros.sortBy === 'placa'"
    }],
    class: ("fa fa-caret-" + _vm.iconSortingDirection)
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.sortResults('dataInicio')
      }
    }
  }, [_vm._v("\n                    Data de Início "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtros.sortBy === 'dataInicio'),
      expression: "filtros.sortBy === 'dataInicio'"
    }],
    class: ("fa fa-caret-" + _vm.iconSortingDirection)
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.sortResults('patioDestino')
      }
    }
  }, [_vm._v("\n                    Pátio de Destino "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtros.sortBy === 'patioDestino'),
      expression: "filtros.sortBy === 'patioDestino'"
    }],
    class: ("fa fa-caret-" + _vm.iconSortingDirection)
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.sortResults('status')
      }
    }
  }, [_vm._v("\n                    Status "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtros.sortBy === 'status'),
      expression: "filtros.sortBy === 'status'"
    }],
    class: ("fa fa-caret-" + _vm.iconSortingDirection)
  })])])]), _vm._v(" "), _c('tbody', [_vm._l(([1, 2, 3]), function(i) {
    return (_vm.isLoading) ? _c('tr', [_c('td', {
      staticClass: "v-middle"
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "20px"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.arrayData), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "v-middle"
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.selected),
        expression: "data.selected"
      }],
      attrs: {
        "type": "checkbox",
        "name": "post[]",
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(data.selected) ? _vm._i(data.selected, null) > -1 : (data.selected)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.lazyCheck(data)
        },
        "change": function($event) {
          var $$a = data.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(data, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(data, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(data, "selected", $$c)
          }
        }
      }
    }), _c('i')])]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(data.agente ? data.agente.nome : data.nomeAgente) + "\n                  ")]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(data.placa) + "\n                  ")]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.moment(data.dataInicio.date).format('DD/MM/YYYY HH:mm')) + "\n                  ")]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(data.patioDestino ? data.patioDestino.nome : '-') + "\n                  ")]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(data.id, data.status)
        }
      }
    }, [_c('span', {
      style: ('color: ' + _vm.StatusTitle(data.status, 'color'))
    }, [_vm._v(_vm._s(_vm.StatusTitle(data.status)))])])])
  }), _vm._v(" "), (_vm.noData) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("Nenhum registro encontrado")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('footer', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 hidden-xs"
  }, [_vm._v("\n                  Mostrar:\n                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pagination.limit),
      expression: "pagination.limit"
    }],
    staticClass: "input-sm form-control w-auto inline v-middle",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pagination, "limit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.paginationLimits), function(p) {
    return _c('option', {
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p))])
  }), 0), _vm._v("\n                  por página\\\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-center"
  }, [_c('small', {
    staticClass: "text-muted inline m-t-sm m-b-sm"
  }, [_vm._v(_vm._s(_vm.pagination.atualPage) + " / " + _vm._s(_vm.pagination.totalPages) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-right text-center-xs"
  }, [_c('u-pagination', {
    attrs: {
      "atual": _vm.pagination.atualPage,
      "total": _vm.pagination.totalPages
    },
    on: {
      "changePage": _vm.changePage
    }
  })], 1)])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35f531ba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/solicitacao-remocao/components/ListaSolicitacoes.vue
// module id = 1783
// module chunks = 18